import { AlertTriangle } from "lucide-react";
import { StatusBadge } from "./StatusBadge";
import { fmtDay } from "./calendarUtils";

// Card lezione: data e corso con lo stesso peso visivo, mai troncati
export const LessonCard = ({ x, color, overlap, onOpen, showDate = true }) => {
  const off = x.status === "cancelled";
  return (
    <button type="button" data-testid={`cal-lesson-${x.id}`} onClick={() => onOpen(x)}
      className={`w-full text-left rounded-lg border border-border bg-white pl-3 pr-2.5 py-2.5 border-l-[6px] hover:bg-muted/40 active:bg-muted/60 transition-colors ${off ? "opacity-55" : ""}`}
      style={{ borderLeftColor: color }}>
      <div className="text-base font-semibold leading-snug text-foreground break-words hyphens-auto">
        {showDate && <span className="capitalize mr-1.5" data-testid={`cal-lesson-date-${x.id}`}>{fmtDay(x.date)}</span>}
        <span className={off ? "line-through" : ""} data-testid={`cal-lesson-course-${x.id}`}>{x.course}</span>
      </div>
      <div className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-1 text-sm text-muted-foreground">
        <span className="text-foreground">{x.start_time}–{x.end_time}</span>
        <span className="break-words">{x.teacher_name || "Docente non indicato"}</span>
        <StatusBadge status={x.status} testid={`cal-lesson-status-${x.id}`} />
      </div>
      {overlap && <p className="text-xs text-amber-700 mt-1 flex items-center gap-1" data-testid={`cal-lesson-overlap-${x.id}`}><AlertTriangle size={12} /> Docente con un'altra lezione sovrapposta</p>}
    </button>
  );
};
